import * as React from "react";
import { cn } from "../lib/utils";

/**
 * Skeleton - a quiet block that stands where content will appear, in the shape
 * of that content (a line of text, a row, a figure).
 *
 * It is decorative: the block says nothing a screen reader can use, so it is
 * hidden from the accessibility tree. Give the REGION that is waiting an
 * `aria-busy` and a label of its own (see `Loader` for a spoken indicator).
 * Size and shape come from `className` (`h-4 w-40`, `size-10 rounded-full`).
 */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      data-slot="skeleton"
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  );
}
